import { Connection } from "reactflow";

export default function isConnectingTwoZapSteps(edge: Connection) {
  const sourceStartsWithZap = edge.source?.startsWith("zap");
  const targetStartsWithZap = edge.target?.startsWith("zap");

  return sourceStartsWithZap && targetStartsWithZap;
}
